import IntegratedAppOptions from 'integrated-app-embedder/IntegratedAppOptions';
import { LiveChatMessages } from './LiveChatMessages';
export default class LiveChatAppOptions extends IntegratedAppOptions {
  setCreateLiveChatAppInit() {
    this.options.push({
      key: LiveChatMessages.CreateLiveChatAppNavigation
    });
    return this;
  }
}